import { format, lastDayOfWeek, parse } from 'date-fns'

export default function (value) {
  const firstDay = parse(value)
  const lastDay = lastDayOfWeek(firstDay, { weekStartsOn: 1 })

  const formattedFirstDay = format(firstDay, 'YYYY-MM-DD')
  const formattedLastDay = format(lastDay, 'YYYY-MM-DD')

  return `${formattedFirstDay} - ${formattedLastDay}`
}



// WEBPACK FOOTER //
// ./src/filters/week-range.js